import {Action} from "@ngrx/store";
import {ImageOptimizerStats} from "../reducers/image-optimizer.reducer";

export const LOAD_IMAGE_OPTIMIZER: string = '[booster] Load Image Optimizer';
export const LOAD_IMAGE_OPTIMIZER_SUCCESS: string = '[booster] Load Image Optimizer success';
export const LOAD_IMAGE_OPTIMIZER_FAIL: string = '[booster] Load Image Optimizer fail';
export const LOAD_IMAGE_OPTIMIZER_AUTO_OPTIMIZE: string = '[booster] Load Image Optimizer Auto Optimize';
export const LOAD_IMAGE_OPTIMIZER_AUTO_OPTIMIZE_SUCCESS: string = '[booster] Load Image Optimizer Auto Optimize success';
export const LOAD_IMAGE_OPTIMIZER_AUTO_OPTIMIZE_FAIL: string = '[booster] Load Image Optimizer Auto Optimize fail';

export class LoadImageOptimizer implements Action {

  readonly type: string = LOAD_IMAGE_OPTIMIZER;
  constructor(public payload: { websiteId: number}) {}

}

export class LoadImageOptimizerSuccess implements Action {

  readonly type: string = LOAD_IMAGE_OPTIMIZER_SUCCESS;
  constructor(public payload: { websiteId: number, stats: ImageOptimizerStats }) {}

}

export class LoadImageOptimizerFail implements Action {

  readonly type: string = LOAD_IMAGE_OPTIMIZER_FAIL;
  constructor(public payload: { websiteId: number}) {}

}

export class LoadImageOptimizerAutoOptimize implements Action {

  readonly type: string = LOAD_IMAGE_OPTIMIZER_AUTO_OPTIMIZE;
  constructor(public payload: { websiteId: number}) {}

}

export class LoadImageOptimizerAutoOptimizeSuccess implements Action {

  readonly type: string = LOAD_IMAGE_OPTIMIZER_AUTO_OPTIMIZE_SUCCESS;
  constructor(public payload: { websiteId: number, autoOptimizeEnabled: boolean }) {}

}

export class LoadImageOptimizerAutoOptimizeFail implements Action {

  readonly type: string = LOAD_IMAGE_OPTIMIZER_AUTO_OPTIMIZE_FAIL;
  constructor(public payload: { websiteId: number}) {}

}

export type ImageOptimizerAction = LoadImageOptimizer | LoadImageOptimizerSuccess | LoadImageOptimizerFail
  | LoadImageOptimizerAutoOptimize | LoadImageOptimizerAutoOptimizeSuccess | LoadImageOptimizerAutoOptimizeFail;
